import React from "react";

import PropTypes from "prop-types";
import { Wrapper } from "./styles";

const Loader = ({ noPd = false, size = 60, color = "primary" }) => (
  <Wrapper color={color} size={size} noPd={noPd}>
    <span className="loader" />
  </Wrapper>
);

Loader.propTypes = {
  noPd: PropTypes.bool,
  size: PropTypes.number,
  color: PropTypes.oneOf([
    "white",
    "light",
    "primary",
    "success",
    "error",
    "warning",
    "info",
  ]),
};

export default Loader;
